import { useState } from "react";
import {
  Button,
  Flex,
  FormLabel,
  Input,
  Text,
  FormControl,
  FormErrorMessage,
  Alert,
  AlertIcon,
  AlertTitle,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import React from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import CustomNotification from "../components/CustomNotification";
import { FaCheckCircle } from "react-icons/fa";
import LoginImage from "../components/LoginImage";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createresetPassword } from "../redux/slices/authSlice";
import { useDispatch } from "react-redux";

export const Cont = ({
  message,
  buttonText,
  link,
  icon = <FaCheckCircle size={"4rem"} color="#5CBF14" />,
  showNotif,
}) => {
  const navigate = useNavigate();

  return (
    <Flex direction="column" alignItems={"center"} justify={"center"}>
      {icon}
      <Text fontWeight={"700"} mt={8}>
        {message}
      </Text>
      <Flex justify={"center"} mt={8}>
        <Button
          onClick={() => {
            showNotif && showNotif(false);
            link && navigate(link);
          }}
        >
          {buttonText}
        </Button>
      </Flex>
    </Flex>
  );
};

const NewPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState(null);
  const [showOtp] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();

  const initialValues = {
    otp: "",
    newPassword: "",
    confirmPassword: "",
  };

  const newPasswordSchema = yup.object().shape({
    otp: yup.string().required("OTP is required"),
    newPassword: yup.string().required("You must enter password"),
    confirmPassword: yup
      .string()
      .required("Please retype your password.")
      .oneOf([yup.ref("newPassword")], "Your password do not match."),
  });

  // const handleSubmit = async (values) => {
  //   setShowNotif(true);
  // };
  //  const handleSubmit = async (values) => {
  //     try {
  //       if (values.newPassword !== values.confirmPassword) {
  //   setError("confirm password must be the same with new password");
  //   return;

  //     } else{
  //        setIsLoading(true);
  //     }
  //       const response = await createresetPassword(values);
  //       // console.log("response login", response);
  //       if (response?.isSuccessful) {
  //         // dispatch(addLoginUser(response?.data));
  //         // console.log(response?.data);

  //         return navigate("/Login");
  //       } else {
  //         throw new Error(
  //           response?.data?.responseDescription || "Something went wrong"
  //         );
  //       }
  //     } catch (error) {
  //       setError(error.message);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  const email = decodeURIComponent(searchParams.get("email") || "");
  const token = decodeURIComponent(searchParams.get("token") || "");

  console.log("Decoded Email:", email);
  console.log("Decoded Token:", token);
  
  

 const handleSubmit = async (values) => {

  if (!email || !token) {
    setError("Missing email or reset token.");
    return;
  }

  if (values.newPassword !== values.confirmPassword) {
    setError("Confirm password must match new password");
    return;
  }

  const payload = {
    email,
    resetPasswordToken: token,
    otp: values.otp,
    newPassword: values.newPassword,
    confirmPassword: values.confirmPassword,
  };

  try {
    setIsLoading(true);
    setError(null);

    const response = await dispatch(createresetPassword(payload)).unwrap();

    if (response?.isSuccessful) {
      setShowNotif(true);
    } else {
      throw new Error(
        response?.data?.responseDescription || "Something went wrong"
      );
    }
  } catch (error) {
    setError(error?.message || "Something went wrong");
  } finally {
    setIsLoading(false);
  }
};




  return (
    <Flex w="full" h="100vh" overflow={"hidden"}>
      {showNotif ? (
        <CustomNotification
          content={
            <Cont
              buttonText={"Go to Login"}
              link={"/"}
              message={"Password Successfully Reset"}
              showNotif={() => {
                setShowNotif(!showNotif);
              }}
            />
          }
        />
      ) : null}
      <LoginImage />
      <Flex
        h={"full"}
        w="full"
        justify={"center"}
        position={"relative"}
        alignItems={"center"}
      >
        <Flex w={["90%", "80%", "90%", "80%"]}>
          <Flex
            direction={"column"}
            bg={"white"}
            width={"full"}
            px={"1.5rem"}
            py="2rem"
          >
            <BiArrowBack
              size={"1.5rem"}
              style={{ marginBottom: "2rem", cursor: "pointer" }}
              onClick={() => navigate("/")}
            />

            <Flex justify={"space-between"} direction={"column"} mb="1.5rem">
              <Text fontWeight={"700"} fontSize={"1.8rem"}>
                Create New Password
              </Text>
              <Text fontSize={"sm"}>
                Enter a unique password to secure your account
              </Text>
            </Flex>

            {error && (
              <Alert status="error" className="mt-3">
                <AlertIcon />
                <AlertTitle>{error}</AlertTitle>
              </Alert>
            )}

            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={newPasswordSchema}
              onSubmit={(values) => handleSubmit(values)}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {({ errors, touched, handleBlur, handleChange }) => (
                <Form mt={4}>
                  <FormControl
                    isInvalid={errors.otp && touched.otp}
                    mb={5}
                    color="black"
                  >
                    <FormLabel>OTP</FormLabel>
                    <InputGroup>
                      <Input
                        pr="4.5rem"
                        type={showOtp ? "number" : "text"}
                        placeholder="Enter your one time password"
                        name="otp"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        bgColor={"#F3F3F3"}
                      />
                    </InputGroup>

                    {touched.otp && errors.otp && (
                      <FormErrorMessage>{errors.otp}</FormErrorMessage>
                    )}
                  </FormControl>

                  <FormControl
                    isInvalid={errors.newPassword && touched.newPassword}
                    mb={5}
                    color="black"
                  >
                    <FormLabel>Create Password</FormLabel>
                    <InputGroup size="lg">
                      <Input
                        pr="4.5rem"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your new password"
                        name="newPassword"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        bgColor={"#F3F3F3"}
                      />
                      <InputRightElement width="4.5rem">
                        <Button
                          h="1.75rem"
                          size="sm"
                          background={"none"}
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <BsEye w={5} h={5} color="GrayText" />
                          ) : (
                            <BsEyeSlash color={"GrayText"} w={5} h={5} />
                          )}
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                    {touched.newPassword && errors.newPassword && (
                      <FormErrorMessage>{errors.newPassword}</FormErrorMessage>
                    )}
                  </FormControl>

                  <FormControl
                    isInvalid={
                      errors.confirmPassword && touched.confirmPassword
                    }
                    mb={5}
                    color="black"
                  >
                    <FormLabel>Confirm Password</FormLabel>
                    <InputGroup size="lg">
                      <Input
                        pr="4.5rem"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm your new password"
                        name="confirmPassword"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        bgColor={"#F3F3F3"}
                      />
                      <InputRightElement width="4.5rem">
                        <Button
                          h="1.75rem"
                          size="sm"
                          background={"none"}
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? (
                            <BsEye w={5} h={5} color="GrayText" />
                          ) : (
                            <BsEyeSlash color={"GrayText"} w={5} h={5} />
                          )}
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                    {touched.confirmPassword && errors.confirmPassword && (
                      <FormErrorMessage>
                        {errors.confirmPassword}
                      </FormErrorMessage>
                    )}
                  </FormControl>

                  <Button
                    isLoading={isLoading}
                    mt={"2rem"}
                    color={"white"}
                    bgColor={"#23A455"}
                    borderRadius="8px"
                    mb="1rem"
                    w={"full"}
                    type="submit"
                  >
                    Send
                  </Button>
                </Form>
              )}
            </Formik>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default NewPassword;
